import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=4169f1b2&scoped=true"
import script from "./TaskForm.vue?vue&type=script&lang=js"
export * from "./TaskForm.vue?vue&type=script&lang=js"
import style0 from "./TaskForm.vue?vue&type=style&index=0&id=4169f1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4169f1b2",
  null
  
)

export default component.exports